export default "/kiban/_next/static/images/04_1L_cupper_base-4188a5357fec38f73d012f54318b42e8.png";